import React from 'react'
import {LB_WL_ACTIVITY} from "../../i18n/i18n";

const WlCardHeader = ({
    icon,
    title,
    subTitle,
    pax
}) => <div className={'wl-card-header'}>
    <div className={'wl-card-header-icon'}>
        <img
            src={require(`../../../assets/images/wishlist/${icon}`)}
            alt={LB_WL_ACTIVITY}
            width={36}
            height={36}
        />
    </div>
    <div className={'wl-card-header-titles'}>
        <div className={'wl-card-title'}>
            { title }
        </div>
        <div className={'wl-card-subtitle'}>
            { subTitle }<br/>
        </div>
    </div>
    <div className={'wl-card-header-pax'}>
        { pax } <i className={'fa fa-users'} aria-hidden='true' />
    </div>
</div>

export default WlCardHeader